import houseWashing from "@/assets/services/house-washing.jpg";
import roofCleaning from "@/assets/services/roof-cleaning.jpg";
import pressureWashing from "@/assets/services/pressure-washing.jpg";
import windowCleaning from "@/assets/services/window-cleaning.jpg";
import gutterCleaning from "@/assets/services/gutter-cleaning.jpg";
import drivewayCleaning from "@/assets/services/driveway-cleaning.jpg";
import fenceCleaning from "@/assets/services/fence-cleaning.jpg";
import deckCleaning from "@/assets/services/deck-cleaning.jpg";
import concreteCleaning from "@/assets/services/concrete-cleaning.jpg";
import solarPanelCleaning from "@/assets/services/solar-panel-cleaning.jpg";

import cWindow from "@/assets/services/commercial-window-cleaning.jpg";
import cBuilding from "@/assets/services/commercial-building-washing.jpg";
import cStorefront from "@/assets/services/commercial-storefront-cleaning.jpg";
import cDriveThrough from "@/assets/services/commercial-drive-through-cleaning.jpg";
import cParkingLot from "@/assets/services/commercial-parking-lot-cleaning.jpg";
import cApartment from "@/assets/services/commercial-apartment-complex-cleaning.jpg";
import cDumpster from "@/assets/services/commercial-dumpster-pad-cleaning.jpg";
import cAwning from "@/assets/services/commercial-awning-cleaning.jpg";
import cGasStation from "@/assets/services/commercial-gas-station-cleaning.jpg";
import cFleet from "@/assets/services/commercial-fleet-washing.jpg";
import cPostConstruction from "@/assets/services/commercial-post-construction.jpg";
import cHoa from "@/assets/services/commercial-hoa-cleaning.jpg";

export const residentialImages: Record<string, string> = {
  "house-washing": houseWashing,
  "roof-cleaning": roofCleaning,
  "pressure-washing": pressureWashing,
  "window-cleaning": windowCleaning,
  "gutter-cleaning": gutterCleaning,
  "driveway-cleaning": drivewayCleaning,
  "fence-cleaning": fenceCleaning,
  "deck-cleaning": deckCleaning,
  "concrete-cleaning": concreteCleaning,
  "solar-panel-cleaning": solarPanelCleaning,
};

export const commercialImages: Record<string, string> = {
  "window-cleaning": cWindow,
  "building-washing": cBuilding,
  "storefront-cleaning": cStorefront,
  "drive-through-cleaning": cDriveThrough,
  "parking-lot-cleaning": cParkingLot,
  "apartment-complex-cleaning": cApartment,
  "dumpster-pad-cleaning": cDumpster,
  "awning-cleaning": cAwning,
  "gas-station-cleaning": cGasStation,
  "fleet-washing": cFleet,
  "post-construction": cPostConstruction,
  "hoa-cleaning": cHoa,
};

export function getServiceImage(category: "residential" | "commercial", slug: string): string | undefined {
  return category === "residential" ? residentialImages[slug] : commercialImages[slug];
}
